import { render, staticRenderFns } from "./disclosure_dropdown.vue?vue&type=template&id=195be152"
import script from "./disclosure_dropdown.vue?vue&type=script&lang=js"
export * from "./disclosure_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports